import { render, staticRenderFns } from "./P41.vue?vue&type=template&id=d63efb38&scoped=true"
import script from "./P41.ts?vue&type=script&lang=ts&external"
export * from "./P41.ts?vue&type=script&lang=ts&external"
import style0 from "./P41.vue?vue&type=style&index=0&id=d63efb38&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63efb38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d63efb38')) {
      api.createRecord('d63efb38', component.options)
    } else {
      api.reload('d63efb38', component.options)
    }
    module.hot.accept("./P41.vue?vue&type=template&id=d63efb38&scoped=true", function () {
      api.rerender('d63efb38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/ProcessesForms/pages/P41/P41.vue"
export default component.exports